import {setBlob, setShow} from 'redux/store/slices/ModalPDF/ModalPDFSlice';

export const showPDF = (blob) => {
  return async (dispatch) => {
    dispatch(setBlob({blob}));
    dispatch(setShow());
  };
};